var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTransmition(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64.8443,
    height: 64,
    rx: 8,
    fill: "#E8EDF9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4636_42587)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.8926 44.3262H21.1152C19.4163 44.3262 18.0391 45.7034 18.0391 47.4023C18.0391 47.7329 18.3071 48.0008 18.6376 48.0008H45.3701C45.7007 48.0008 45.9686 47.7328 45.9686 47.4023C45.9687 45.7034 44.5915 44.3262 42.8926 44.3262Z",
    fill: "url(#paint0_linear_4636_42587)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9892 42.4403H41.019C41.3496 42.4403 41.6176 42.1723 41.6176 41.8417C41.6176 40.1428 40.2404 38.7656 38.5415 38.7656H25.4667C23.7678 38.7656 22.3906 40.1428 22.3906 41.8417C22.3906 42.1723 22.6586 42.4403 22.9892 42.4403Z",
    fill: "url(#paint1_linear_4636_42587)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6299 36.976H37.3729C37.7035 36.976 37.9714 36.708 37.9714 36.3775C37.9714 34.6786 36.5942 33.3014 34.8953 33.3014H33.0059V27.8674H34.7542C35.2261 27.8674 35.6244 27.5164 35.6836 27.0481C35.8033 26.1021 36.2797 21.7163 36.3981 20.7817C36.5559 19.5367 36.2008 18.381 35.3711 17.4395C34.5827 16.5447 33.4748 16.0263 32.282 16.0012C30.9534 15.9733 29.6566 16.4279 28.7651 17.4392C27.9354 18.3805 27.5802 19.5361 27.7378 20.781C27.8551 21.7075 28.3324 26.094 28.4537 27.0486C28.5131 27.5167 28.9113 27.8674 29.3831 27.8674H31.1321V33.3014H29.1074C27.4085 33.3014 26.0312 34.6786 26.0312 36.3775C26.0314 36.7081 26.2993 36.976 26.6299 36.976Z",
    fill: "url(#paint2_linear_4636_42587)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4636_42587",
    x1: 18.0391,
    y1: 44.3262,
    x2: 23.733,
    y2: 57.5646,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2836D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E93D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4636_42587",
    x1: 22.3906,
    y1: 38.7656,
    x2: 29.4401,
    y2: 50.0486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2836D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E93D7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4636_42587",
    x1: 26.0312,
    y1: 16,
    x2: 41.165,
    y2: 18.6352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2836D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E93D7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4636_42587"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransmition);
export default __webpack_public_path__ + "static/media/transmition.e02656d7de71ed715c0ff1cce53ef97d.svg";
export { ForwardRef as ReactComponent };